"use client"

import { Text } from "@/elements"
import { ChevronLeftIcon } from "@/icons/outline/ChevronLeftIcon"
import { ChevronRightIcon } from "@/icons/outline/ChevronRightIcon"
import { useCallback, useEffect } from "react"
import ReactDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { YearPicker } from "./YearPicker"

interface Props {
  endDate: Date | undefined
  startDate: Date | undefined
  onChange: (dates: any) => void
  minDate?: Date
  maxDate?: Date
  selectsRange?: boolean
  yearPicker?: boolean
}

const CustomHeader = ({
  yearPicker,
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  changeYear,
}: any) => {
  return (
    <div className="flex w-full flex-row items-center justify-between pl-4 pr-3">
      <div className="flex flex-row gap-x-2">
        <Text variant="h5">
          {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
        </Text>
        {yearPicker ? <YearPicker changeYear={changeYear} date={date} /> : null}
      </div>
      <div className="flex flex-row gap-1">
        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
          <ChevronLeftIcon className="color-primary-3 stroke-primary-3" />
        </button>
        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
          <ChevronRightIcon className="color-primary-3 stroke-primary-3" />
        </button>
      </div>
    </div>
  )
}

export const DateRangePicker: React.FC<Props> = ({
  startDate,
  endDate,
  onChange,
  minDate,
  maxDate,
  selectsRange = true,
  yearPicker = false,
}) => {
  const addCustomElements = useCallback(() => {
    const days = document.querySelectorAll(".react-datepicker__day")
    days.forEach(day => {
      const dayContent = day.textContent
      if (dayContent && !day.querySelector(".react-datepicker__day--inner-element")) {
        const contentWrapper = document.createElement("div")
        contentWrapper.className = "react-datepicker__day--content-wrapper" // Add your custom class
        contentWrapper.textContent = dayContent

        // Clear the original text content
        day.textContent = ""

        // Append the new wrapper with the day content inside
        day.appendChild(contentWrapper)
      }

      if (!day.querySelector(".react-datepicker__day--inner-element")) {
        const customDiv = document.createElement("div")
        customDiv.className = "react-datepicker__day--inner-element" // Add your custom class

        day.insertBefore(customDiv, day.firstChild)
      }
    })
  }, [])

  useEffect(() => {
    // Add a div to each day
    addCustomElements()
  }, [addCustomElements])

  return (
    <ReactDatePicker
      onMonthChange={addCustomElements}
      selected={startDate}
      onChange={onChange}
      onYearChange={addCustomElements}
      startDate={startDate}
      shouldCloseOnSelect={false}
      endDate={endDate}
      {...(selectsRange && { selectsRange: true })}
      selectsMultiple={undefined}
      minDate={minDate}
      maxDate={maxDate}
      inline
      renderCustomHeader={props => <CustomHeader {...props} yearPicker={yearPicker} />}
      showYearDropdown={true}
    />
  )
}
